import { Suspense } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute, PublicRoute, RootRedirect } from "app/authGuards";
import { RouteFallback } from "components";
import {
  AdminPage,
  ClientPage,
  CommandePage,
  DemandePage,
  ForgotPassword,
  HomePage,
  LoginPage,
  NoAccessPage,
  StPage,
} from "components/Pages";

export default function AppRoutes() {
  return (
    <Router>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/Accueil"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Clients"
            element={
              <ProtectedRoute>
                <ClientPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Sous-traitants"
            element={
              <ProtectedRoute>
                <StPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Demande"
            element={
              <ProtectedRoute>
                <DemandePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Commande"
            element={
              <ProtectedRoute>
                <CommandePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/No-access"
            element={
              <ProtectedRoute>
                <NoAccessPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </Router>
  );
}
